import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import { useCreateNewAllergen, useDeleteAllergen, useGetAllergens } from "../../../network";
import { FormField } from "../../../components/FormField";
import { PuffLoader } from "react-spinners";

export const MenuAllergens = ({ visible, onClose, onSave }) => {
    const [searchValue, setSearchValue] = useState("");
    const { data: { data: allergens = [] } = {} } = useGetAllergens();
    const { mutate: addNewAllergen, isLoading: isAdding, mutateAsync: addNewAllergenAsync } = useCreateNewAllergen()
    const { mutate: deleteAllergen, isLoading: isDeleting } = useDeleteAllergen()
    const { t } = useTranslation();

    const searchHandle = (e) => {
        setSearchValue(e.target.value);
    };

    const sendAllergens = async (searchValue) => {
        const multipleAllergens = searchValue.split(' ')
        const isMultiple = multipleAllergens.length > 1

        if(isMultiple) {
            for await (const allergen of multipleAllergens) {
                await addNewAllergenAsync(
                    { name: allergen }
                );
            }
            setSearchValue('');
        } else {
            addNewAllergen(
                { name: searchValue },
                {
                    onSuccess: () => {
                        setSearchValue('');
                    },
                }
            );
        }
    }

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter' && searchValue) {
            await sendAllergens(searchValue)
        }
    };

    const onAdd = async () => {
        if (searchValue) {
            await sendAllergens(searchValue)
        }
    };

    const filteredAllergens = allergens?.filter((item) => item.name.toLowerCase().includes(searchValue.toLowerCase()));

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-4xl sm:mx-auto"
            style={{
                overlay: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(107, 114, 128, 0.75)",
                },
                content: { overflow: "hidden" },
            }}
        >
            <div className="flex">
                <div className="mx-10 pt-12">
                    <div className="flex gap-4 items-end font-bold text-lg mb-2">
                        {t("Allergen & Dietary Database")}
                        {isAdding || isDeleting? (
                            <div className="mb-1">
                                <PuffLoader color="#7A5AF8" size={18} />
                            </div>
                        ): null}
                    </div>
                    <div className="font-medium text-sm">
                        {t("In line with Natasha's law, it's mandatory to list allergen information at the time of purchase. Below are all the relevant allergens for you to apply to new and existing products. You may also create other non-mandatory allergen & dietary tags.")}
                    </div>

                    <div className="mb-5 mt-2 border-2 p-4 border-blue-700 rounded-md w-11/12">
                        <div className="flex justify-between gap-4 ">
                            <FormField className="w-full">
                            <input
                                type="text"
                                name="Create Allergens"
                                value={searchValue}
                                onChange={searchHandle}
                                onKeyDown={handleKeyDown}
                                disabled={isAdding || isDeleting}
                                placeholder={t(
                                    "Create a new allergen or dietary tag"
                                )}
                                className="input border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            </FormField>
                            <button
                                onClick={onAdd}
                                type="button"
                                disabled={isAdding}
                                className="inline-flex disabled:opacity-25 disabled:cursor-default justify-center py-2 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            >
                                {t("Add")}
                            </button>
                        </div>

                        <div className="flex flex-wrap mt-4">
                            {filteredAllergens.map(({ name, id }) => (
                                <div
                                    key={id}
                                    className="mr-3 bg-gray-300 rounded-full mb-1 py-1 px-4 w-max font-bold text-xs whitespace-nowrap"
                                >
                                    <span>{name}</span>
                                    <button disabled={isAdding || isDeleting} className="ml-3" onClick={() => deleteAllergen({ id })}>X</button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="py-5 px-5 text-right flex items-end">
                    <button
                        type="button"
                        className="inline-flex justify-center mr-2 py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg bg-gray-100 hover:bg-gray-200 activ:bg-gray-500 focus:outline-none"
                        onClick={onClose}
                    >
                        {t("Close")}
                    </button>
                </div>
            </div>
        </Modal>
    );
};
